import _defineProperty from "/Users/alvaramat/game-dices/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/alvaramat/game-dices/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { useProgress } from '../core/useProgress.js';

var defaultDataInterpolation = function defaultDataInterpolation(p) {
  return "Loading ".concat(p, "%");
};

function Loader(_ref) {
  var containerStyles = _ref.containerStyles,
      innerStyles = _ref.innerStyles,
      barStyles = _ref.barStyles,
      dataStyles = _ref.dataStyles,
      _ref$dataInterpolatio = _ref.dataInterpolation,
      dataInterpolation = _ref$dataInterpolatio === void 0 ? defaultDataInterpolation : _ref$dataInterpolatio,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? function (active) {
    return active;
  } : _ref$initialState;

  var _useProgress = useProgress(),
      active = _useProgress.active,
      progress = _useProgress.progress;

  var progressRef = React.useRef(0);
  var rafRef = React.useRef(0);
  var progressSpanRef = React.useRef(null);

  var _React$useState = React.useState(initialState(active)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shown = _React$useState2[0],
      setShown = _React$useState2[1];

  React.useEffect(function () {
    var t;
    if (active !== shown) t = setTimeout(function () {
      return setShown(active);
    }, 300);
    return function () {
      return clearTimeout(t);
    };
  }, [shown, active]);
  var updateProgress = React.useCallback(function () {
    if (!progressSpanRef.current) return;
    progressRef.current += (progress - progressRef.current) / 2;
    if (progressRef.current > 0.95 * progress || progress === 100) progressRef.current = progress;
    progressSpanRef.current.innerText = dataInterpolation(progressRef.current);
    if (progressRef.current < progress) rafRef.current = requestAnimationFrame(updateProgress);
  }, [dataInterpolation, progress]);
  React.useEffect(function () {
    updateProgress();
    return function () {
      return cancelAnimationFrame(rafRef.current);
    };
  }, [updateProgress]);
  return shown ? /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.container), {}, {
      opacity: active ? 1 : 0
    }, containerStyles)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.inner), innerStyles)
  }, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.bar), {}, {
      transform: "scaleX(".concat(progress / 100, ")")
    }, barStyles)
  }), /*#__PURE__*/React.createElement("span", {
    ref: progressSpanRef,
    style: _objectSpread(_objectSpread({}, styles.data), dataStyles)
  })))) : null;
}

var styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#171717',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 300ms ease',
    zIndex: 1000
  },
  inner: {
    width: 100,
    height: 3,
    background: '#272727',
    textAlign: 'center'
  },
  bar: {
    height: 3,
    width: '100%',
    background: 'white',
    transition: 'transform 200ms',
    transformOrigin: 'left center'
  },
  data: {
    display: 'inline-block',
    position: 'relative',
    fontVariantNumeric: 'tabular-nums',
    marginTop: '0.8em',
    color: '#f0f0f0',
    fontSize: '0.6em',
    fontFamily: "-apple-system, BlinkMacSystemFont, \"Inter\", \"Segoe UI\", \"Helvetica Neue\", Helvetica, Arial, Roboto, Ubuntu, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    whiteSpace: 'nowrap'
  }
};
export { Loader };